import { NetworkStatus } from '@apollo/client';
import getIn from 'immutable-less/transmute/getIn';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { PLATFORM } from 'automation-ui-flow-core/flow/FlowSourceTypes';
import { FLOW_REFERENCES_FIELDNAME } from 'automation-ui-management/queries/flowReferenceQueries';
import { useFlowReferences } from 'automation-ui-management/hooks/flowReferencesHook';
import InboundFlowReferencesSection from 'automation-ui-management/components/workflow-references/InboundFlowReferencesSection';
import WorkflowReferenceFailureAlert from 'automation-ui-management/components/workflow-references/WorkflowReferenceFailureAlert';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CloneWorkflowReferencesSection = ({
  flowId
}) => {
  const {
    data,
    loading,
    error,
    networkStatus,
    refetch
  } = useFlowReferences({
    flowId,
    flowSource: PLATFORM,
    notifyOnNetworkStatusChange: true
  });
  const inboundReferences = getIn([FLOW_REFERENCES_FIELDNAME, 'inboundReferences'], data);
  if (loading || networkStatus === NetworkStatus.refetch) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.CloneWorkflowReferencesSection.checkingReferences"
      }),
      showLabel: true
    });
  } else if (error) {
    return /*#__PURE__*/_jsx(WorkflowReferenceFailureAlert
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    , {
      handleRequestReferences: () => refetch()
    });
  } else if (inboundReferences && inboundReferences.length) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-management.CloneWorkflowReferencesSection.inboundReferencesExplanation"
        })
      }), /*#__PURE__*/_jsx(InboundFlowReferencesSection, {
        inboundReferences: inboundReferences
      })]
    });
  }
  return null;
};
export default CloneWorkflowReferencesSection;